import {UserManager, Log, WebStorageStateStore} from 'oidc-client-ts';
import Configuration from './ConfigProvider';

/**
 * OIDC `UserManager` singleton (default export kept as `SecurityService` for existing imports).
 * `loadUserInfo: false` — profile claims come from the ID token (or app logic), not the UserInfo endpoint.
 * `accessTokenExpiringNotificationTime: 10` — seconds before expiry; below library default; confirm for your IdP.
 */
const SecurityService = new UserManager({
  userStore: new WebStorageStateStore(),
  authority: Configuration.value('oidcAuthority'),
  client_id: Configuration.value('oidcClientId'),
  redirect_uri: globalThis.location.origin + '/callback',
  response_type: 'code',
  scope: Configuration.value('oidcScope'),
  post_logout_redirect_uri: globalThis.location.origin + '/callback_logout',
  silent_redirect_uri: globalThis.location.origin + '/callback_silent',
  accessTokenExpiringNotificationTime: 10,
  automaticSilentRenew: true,
  filterProtocolClaims: true,
  loadUserInfo: false,
});

/** Library-global log level; reduce in production if logs are too noisy. */
Log.logger = console;
Log.level = Log.INFO;

SecurityService.events.addUserSignedOut(function () {
  SecurityService.signoutRedirect();
});

export default SecurityService;
